<template>
  <div class="workflow-view new-view-layout">
    <van-loading v-if="isFetching" color="black" />
    <div class="workflow-view-main" v-if="!isFetching">
      <div class="workflow-detail">
        <message-card title="审批内容" :info="messageInfo">
          <template slot="file" v-if="workflowFile">
            <div class="message-file">
              <new-file-item :file="workflowFile" :extraParams="previewExtraParams"/>
            </div>
          </template>
          <template slot="status">
            <div class="review-status" :class="status">
              <img :src="getReviewBadge('workflow', status)[0]"/>
              <span>{{getReviewBadge('workflow', status)[1]}}</span>
            </div>
          </template>
          <div class="workflow-file" v-if="attachmentsArr.length">
            <span>附件</span>
            <div class="file-wrap">
              <div class="workflow-file-item" ref="workflowFile">
                <new-file-item v-for="file in attachmentsArr" :key="file.fileId" :file="file" :extraParams="previewExtraParams"/>
              </div>
              <div class="open-file" v-if="attachmentsArr.length > 3" @click="handleCollapse">{{fileText}}所有文件</div>
            </div>

          </div>
        </message-card>
        <message-card title="审阅流程">
          <Steps direction="vertical">
            <Step
              v-for="(node, index) in nodes"
              :key="node.id"
              :nodeClass="getCurNode() === index ? 'cur-node' : ''"
            >
              <h5>{{node.name}} <span :style="{color: getNodesStatus(node)[0].color}">{{node.type === 1 ? '发起审批' : getNodesStatus(node)[0].text}}</span></h5>
              <div class="review-user-wrap">
                <div class="review-user">
                  <div class="user-avatar" v-if="node.type === 1" @click="userDetail(workflowInfo.author.id)">
                    <avatar
                      :user="workflowInfo.author"
                      :size="30"
                    />
                    <em class="pre-ellipsis">{{ workflowInfo.author.name }}</em>
                  </div>
                  <template v-for="(user, index) in node.approveUsers">
                    <div class="user-avatar"
                      v-if="node.type !== 1"
                      :key="index"
                      @click="userDetail(user.approveUser.id)"
                    >
                      <img v-if="user.taskStatus === 1 && user.approveUser.id === user_info.id" class="status-icon" :src="require('@/assets/embedAppPageImg/ongoing.svg')" />
                      <img v-if="user.taskStatus === 2" class="status-icon" :src="require('@/assets/embedAppPageImg/pass.svg')" />
                      <img v-if="user.taskStatus === 7" class="status-icon" :src="require('@/assets/embedAppPageImg/back.svg')" />
                      <img v-if="user.taskStatus === 3" class="status-icon" :src="require('@/assets/embedAppPageImg/reject.svg')" />
                      <!-- <img v-if="nodes.rejected && nodes.rejectedUser.user.id === user.id" class="status-icon" :src="require('@/assets/embedAppPageImg/reject.svg')" /> -->
                      <avatar
                        :user="user.approveUser"
                        :size="30"
                      />
                      <em class="pre-ellipsis">{{ user.approveUser.name }}</em>
                    </div>
                    <div class="user-right-icon" :key="user.approveUser.id" v-if="node.handleType === 0 && index !== node.approveUsers.length -1">
                      <img src="@/assets/embedAppPageImg/act_add.svg"/>
                    </div>
                    <div class="user-right-icon" :key="user.approveUser.id" v-if="node.handleType === 2 && index !== node.approveUsers.length -1">
                      <img src="@/assets/embedAppPageImg/page_arrow2.svg"/>
                    </div>
                  </template>
                </div>
              </div>
            </Step>
          </Steps>
        </message-card>
        <message-card title="抄送人" v-if="visitorList && visitorList.length">
          <div class="review-user visitor-user">
            <div class="user-avatar"
              v-for="user in visitorList"
              :key="user.id"
              @click="userDetail(user.id)"
            >
              <avatar
                :user="user"
                :size="30"
              />
              <em class="pre-ellipsis">{{ user.name }}</em>
            </div>
          </div>
        </message-card>
      </div>
      <workflow-form :workflowInfo="workflowInfo" :currentNodeIndex="currentNodeIndex" />
    </div>
    <van-popup
      class="workflow-action"
      v-model="showActions"
      position="right"
    >
      <workflow-action :workflowInfo="workflowInfo" :currentNodeIndex="currentNodeIndex" />
    </van-popup>
    <van-popup
      class="workflow-action"
      v-model="showBack"
      position="right"
    >
      <workflow-back :workflowInfo="workflowInfo" :currentNodeIndex="currentNodeIndex" />
    </van-popup>
  </div>
</template>

<script>
import {formatDate, goToUserDetail} from '@/utils/common'
import NewFileItem from '../components/NewFileItem'
import ajax from '@/utils/ajax'
import {GET_TASK_DETAIL} from '@/config/api'
import config from '@/config'
import MessageCard from '../components/MessageCard'
import { normalizeFile } from '@/utils/fileUtils'
import { getReviewBadge } from '../utils/RAWUtils'
import Steps from '../components/Steps'
import Step from '../components/Step'
import Avatar from '../../utils/Avatar'
import WorkflowForm from './WorkflowForm'
import { findIndex } from 'lodash'
import WorkflowBack from './WorkflowBack'
import WorkflowAction from './WorkflowAction'
import { Toast } from 'vant'

export default {
  name: 'WorkflowView',
  components: {
    MessageCard,
    NewFileItem,
    Steps,
    Step,
    Avatar,
    WorkflowForm,
    WorkflowBack,
    WorkflowAction
  },
  data () {
    return {
      isFetching: false,
      workflowFile: null,
      workflowInfo: null,
      nodes: null,
      visitorList: null,
      currentNodeIndex: -1,
      user_info: config.user_info || {},
      showActions: false,
      showBack: false,
      fileText: '展开',
      attachmentsArr: [],
      previewExtraParams: {}
    }
  },
  beforeCreate () {
    this.$router.replace({ query: {} })
  },
  watch: {
    $route (to, from) {
      const {showActions, showBack} = from.query
      this.showActions = !!to.query.showActions
      this.showBack = !!to.query.showBack
      if (['agree', 'disagree', ''].includes(showActions) || ['back'].includes(showBack)) {
        this.fetchWorkflowInfo()
      }
    }
  },
  computed: {
    messageInfo () {
      const { author, submitTime, workflowNo, desc } = this.workflowInfo
      return [{
        'label': '发起人',
        'text': author && author.name
      }, {
        'label': '发起时间',
        'text': submitTime || formatDate(Date.now(), '%YY-%MM-%DD %hh:%mm')
      }, {
        'label': '流水号',
        'text': workflowNo
      }, {
        'label': '备注',
        'text': desc
      }]
    },
    status () {
      return this.workflowStatus(this.workflowInfo.workflowStatus)
    }
  },
  created () {
    document.title = '工作流详情'
    this.fetchWorkflowInfo()
  },
  methods: {
    getReviewBadge,
    userDetail (id) {
      goToUserDetail(id)
    },
    formatDate,
    handleCollapse () {
      if (this.$refs.workflowFile.style.height === 'auto') {
        this.$refs.workflowFile.style.height = '96px'
        this.$refs.workflowFile.style.maxHeight = '96px'
        this.fileText = '展开'
      } else {
        this.$refs.workflowFile.style.height = 'auto'
        this.$refs.workflowFile.style.maxHeight = 'initial'
        this.fileText = '收起'
      }
    },
    getCurNode () {
      const { currentNodeId, nodes } = this.workflowInfo
      let curr
      nodes.some((ele, index, arr) => {
        if (ele.id === currentNodeId) {
          curr = index
          return true
        }
      })
      return curr
    },
    getNodesStatus (nodes) {
      const { taskStatus } = nodes
      const STATUS = [
        {
          value: 0,
          text: '发起审批',
          color: '#626F84'
        },
        {
          value: 4,
          text: '等待中',
          color: '#9BA7BA'
        },
        {
          value: 1,
          text: '审批中',
          color: '#FFA31A',
          icon: 'icon-state-ongoing'
        },
        {
          value: 2,
          text: '已通过',
          color: '#4EC01E',
          icon: 'icon-state-success'
        },
        {
          value: 3,
          text: '已拒绝',
          color: '#FF5E68',
          icon: 'icon-state_error'
        },
        {
          value: 5,
          text: '已完成',
          color: '#4EC01E',
          icon: 'icon-state-success'
        },
        {
          value: 6,
          text: '已关闭',
          color: '#9BA7BA'
        },
        {
          value: 7,
          text: '已退回',
          color: '#FF5E68',
          icon: 'icon-state-back'
        }
      ]
      return STATUS.filter(item => item.value === taskStatus)
    },
    workflowStatus () {
      const { workflowStatus } = this.workflowInfo
      const status = {
        1: 'processing',
        2: 'passed',
        6: 'closed',
        3: 'rejected',
        7: 'returned'
      }
      return status[workflowStatus]
    },
    fetchWorkflowInfo () {
      this.isFetching = true
      ajax({
        url: GET_TASK_DETAIL,
        data: {taskId: this.$route.params.id}
      }).then(res => {
        if (res && res.success) {
          const { nodes, ccUsers, currentNodeId } = res.data
          if (nodes.length) {
            const { workflowFileItem } = nodes[0]
            const { name } = workflowFileItem || {}
            const currentNodeIndex = findIndex(nodes, { id: currentNodeId })
            this.workflowFile = workflowFileItem && normalizeFile({...workflowFileItem, extension: name.indexOf('.') > -1 ? name.split('.')[name.split('.').length - 1] : ''})
            this.workflowInfo = res.data
            this.nodes = nodes
            this.visitorList = ccUsers
            this.currentNodeIndex = currentNodeIndex
            this.previewExtraParams = { scenario: 'workflow', templateId: res.data.templateId, workflowNo: res.data.workflowNo }
            this.attachmentsArr = nodes[0].attachments.map(item => {
              const arr = item.name.split('.')
              let _type = arr.length >= 2 ? arr[arr.length - 1] : ''
              return normalizeFile({
                ...item,
                extension: _type
              })
            })
          }
          this.isFetching = false
        } else {
          Toast('获取工作流消息失败，请重试')
        }
      })
    }
  }
}

</script>

<style  lang="postcss">
@import 'variables';
.workflow-view-main {
  & .message-card {
    margin-bottom: 12px;

    & .message-info {
      padding-bottom: 8px;
    }

    & .workflow-file {
      font-weight: 400;
      font-size: 12px;
      line-height: 20px;
      color: #9BA7BA;
      margin-bottom: 2px;
      display: flex;
      margin-bottom: 12px;
      color: #626F84;

      & span {
        margin-right: 16px;
        display: flex;
        min-width: 48px;
        width: 48px;
        color: #9BA7BA;
      }

      & .file-wrap {
        display: flex;
        flex-direction: column;

        & .workflow-file-item {
          max-height: 96px;
          overflow: hidden;
          & .new-file-item {
            & .file-name {
              max-width: 200px;
            }
          }
        }

        & .new-file-item {
          margin-bottom: 12px;
          padding: 0;
          height: 20px;
          line-height: 20px;
          align-items: center;

          & .file-name {
            font-size: 12px;
            font-weight: 400;
            color: #252E36;
            line-height: 20px;
            margin-bottom: 0;
          }

          & .file-icon {
            width: 16px;
            height: 16px;

            & img {
              width: 16px;
              height: 16px;
            }
          }

          & .file-size {
            display: none;
          }
        }
      }

      & .open-file {
        color: #006BFF;
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
      }
    }

    & .user-right-icon {
      margin-right: 4px;
      margin-top: 12px;

      & img {
        width: 16px;
        height: 16px;
      }
    }

    & .workflow-input {

      &.van-cell {
        padding-left: 0;
      }
    }
  }
}

</style>
